<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
      <div class="page-title">
        <h2>Farm Zones</h2>
        <v-spacer></v-spacer>

        <v-btn
          color="primary"
          dark
          outlined
          @click="$router.push({ name: 'FarmLists' })"
          class="mr-2"
        >
          {{ $t("Back") }}
        </v-btn>
        <v-btn
          :disabled="farm && !farm.FarmCoordinates.length"
          depressed
          color="primary"
          @click="$router.push({ name: 'FarmZones' })"
        >
          {{ $t("Add New Zones") }}
        </v-btn>
      </div>
      <v-card elevation="0" class="px-5">
        <v-card-text v-if="items.length > 0">
          <v-data-table
            :headers="headers"
            :items="items"
            v-model="selected"
            item-key="farmNumber"
            :items-per-page="25"
            :loading="loading"
            loading-text="Loading Farms... Please wait"
            hide-default-footer
            :footer-props="{
              'items-per-page-options': [5, 10, 25],
              'show-first-last-page': true,
              'show-current-page': true,
              'items-per-page-text': 'Farms per page',
            }"
          >
            <template v-slot:top>
              <div class="d-flex mt-5">
                <v-spacer></v-spacer>
              </div>
            </template>
            <template v-slot:progress>
              <v-progress-linear
                color="primary"
                :height="8"
                indeterminate
              ></v-progress-linear>
            </template>
            <template v-if="items.length > 0" v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td>{{ item.geofenceName }}</td>
                  <td>0</td>
                  <td>0</td>
                  <td>
                    {{ item.geofenceParameter }}
                    {{ item.geofenceAreaUOMId === 1 ? "F" : "M" }}
                  </td>
                  <td>
                    {{ item.geofenceArea }}
                    {{ item.geofenceAreaUOMId === 1 ? "A" : "H" }}
                  </td>
                  <td class="text-center">
                    <v-btn
                      depressed
                      plain
                      color="blue"
                      @click="editZone(item)"
                      x-small
                      style="height: 100%"
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn
                      plain
                      color="red"
                      @click="deleteZone(item)"
                      x-small
                      style="height: 100%"
                    >
                      <v-icon>mdi-trash-can</v-icon>
                    </v-btn>
                    <v-btn
                      plain
                      color="red"
                      @click="rowClicked(item)"
                      x-small
                      style="height: 100%"
                    >
                      <v-icon>mdi-eye</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-card-text>

        <div class="text-center white" style="min-height: 70vh" v-else>
          <v-row justify="center" align="center">
            <v-col cols="12" sm="4">
              <div class="py-16">
                <img src="/img/Notes.svg" /><br />
                <!-- <strong>No Farm Found</strong><br /> -->
                <div class="pb-4">
                  <small
                    v-if="farm && !farm.FarmCoordinates.length"
                    class="red--text"
                    >Geofence is required to add zone. Click `Edit Farm` to add
                    Geofence details to your farm.</small
                  >
                  <small v-else
                    >No Zones have been created yet.
                    <br />
                    Please click on Add Zones to create a Zone for this
                    farm.</small
                  >
                </div>
                <v-btn
                  depressed
                  color="primary"
                  @click="$router.push({ name: 'FarmZones' })"
                  v-if="farm && farm.FarmCoordinates.length"
                >
                  {{ $t("Add New Zones") }}
                </v-btn>
                <v-btn
                  v-else
                  depressed
                  color="primary"
                  @click="$router.push({ name: 'EditPrimaryFarm' })"
                >
                  {{ $t("farm.editFarm") }}
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-container>
    <ConfirmBax
      v-if="deleteconfirm"
      :dialog="deleteconfirm"
      :title="confirmboxinfo.title"
      confirmBtnText="Delete"
      :confirmData="itemToDelete"
      @confirm:action="deleteConfirmed"
    />
  </div>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin";
import Breadcrumb from "@/components/core/Breadcrumb";
import FarmService from "@/_services/farmService";
import { removeSegment } from "@/graphql/Farm.gql";
import ConfirmBax from "@/components/ConfirmBox.vue";
export default {
  components: {
    breadcrumb: Breadcrumb,
    ConfirmBax,
  },
  watch: {
    tableOptions: {
      handler() {
        this.getfarm();
      },
      deep: true,
    },
  },
  async mounted() {
    document.title = this.$t("farm.farms");
    this.selectedHeaders = this.allSelectedHeaders;
    this.getPrimaryFarm();
  },

  computed: {
    checkBreakPoints() {
      if (this.$vuetify.breakpoint.width <= 980) return true;
      return false;
    },
  },
  methods: {
    async getPrimaryFarm() {
      const farm = await FarmService.getFarm(this.$route.params.id);
      this.farm = farm.data;
      // console.log('farm', this.farm)
      this.items = this.farm.GeoFences;
      this.loading = false;
    },
    deleteConfirmed(action, data) {
      if (action) {
        this.removeZone(data);
      }
      this.itemToDelete = null;
      this.deleteconfirm = false;
    },

    deleteZone(item) {
      this.itemToDelete = item;
      this.deleteconfirm = true;
    },
    removeZone(item) {
      this.startLoading();
      this.$apollo
        .mutate({
          mutation: removeSegment,
          variables: {
            id: parseInt(item.id),
          },
        })
        .then(res => {
          console.log("res", res);
          this.getPrimaryFarm();
          this.stopLoading();
        })
        .catch(e => {
          console.log("error", e);
          this.stopLoading();
        });
    },
    editZone(item) {
      this.$router.push({ name: "FarmEditZone", params: { id: item.id } });
    },
    selectItem(item) {
      this.selectedItem = item;
    },
    unSelectItem() {
      this.selectedItem = false;
    },
    goToFarm(frmNum) {
      this.$router.push({ name: "SingleFarm", params: { id: frmNum } });
    },
    pageChange(t) {
      if (t) this.tableOptions.page = this.tableOptions.page + 1;
      else this.tableOptions.page = this.tableOptions.page - 1;

      this.getfarm();
    },
    rowClicked(item) {
      this.$router.push({
        name: "ZoneDetails",
        params: { id: item.id },
      });
    },
  },
  data() {
    return {
      farm: null,
      deleteconfirm: false,
      itemToDelete: null,
      confirmboxinfo: {
        title: "Delete Zone",
      },
      menu: false,
      itemsPerPageSlider: 0,
      itemsPerPageOptions: [5, 10, 25, 50],

      to: "",
      from: "",
      totalPages: "",
      search: "",
      selected: [],
      items: [],
      totalfarms: 1,
      selectedItem: false,
      loading: true,
      length: 0,
      pageCount: 1,
      tableOptions: {},
      tabletTableOptions: { itemsPerPage: 10, page: 1, sortBy: [] },
      loadingText: "Loading... Please wait",
      breadcrumbs: [
        {
          text: this.$t("dashboard"),
          disabled: false,
          to: "/",
        },
        {
          text: this.$t("farm.farms"),
          link: true,
          exact: true,
          disabled: false,
          to: { name: "My farm" },
        },
        {
          text: this.$t("farm.zones"),
          disabled: true,
          to: { name: "ZonesList" },
        },
      ],
      headers: [
        {
          text: this.$t("Zone Name"),
          align: "start",
          value: "farmName",
          class: "black--text",
        },
        {
          text: this.$t("# of Animal Groups"),
          align: "start",
          value: 0,
          class: "black--text",
        },
        {
          text: this.$t("Total # of Animals"),
          align: "start",
          value: 0,
          class: "black--text",
        },
        {
          text: this.$t("Perimeter"),
          align: "start",
          value: "farmName",
          class: "black--text",
        },
        {
          text: this.$t("Area"),
          value: "govRegistrationNum",
          class: "black--text",
        },
        {
          text: this.$t("Actions"),
          class: "black--text",
          align: "center center",
          sortable: false,
        },
      ],

      selectedHeaders: [],
      oldSelected: [],
      noRecordHeader: [
        this.$t("farm.farmOwner"),
        this.$t("farm.farmType"),
        this.$t("farm.contractMating"),
        this.$t("farm.govtRegistry"),
        this.$t("farm.cooperativeID"),
      ],
      allSelectedHeaders: [
        this.$t("farm.farmId"),
        this.$t("farm.farmOwner"),
        this.$t("farm.farmType"),
        this.$t("farm.contractMating"),
        this.$t("farm.govtRegistry"),
        this.$t("farm.cooperativeID"),
      ],

      // users: [],
    };
  },
  mixins: [loadingMixin],
};
</script>

<style lang="scss" scoped>
::v-deep .v-data-table-header {
  background: $secondary2-color;
}

::v-deep .v-data-table-header span {
  // text-transform: uppercase !important;
  color: black;
}

::v-deep .v-data-table-header th {
  white-space: nowrap;
}

.table-header {
  background: $secondary2-color;
}

.table-header-span {
  text-transform: uppercase !important;
  color: black !important;
}
</style>
